import React from 'react';
import '../../styles/cta_nav.scss';

const PostJobCtaBanner = () => {
  const JOB_POSTING_OPTIONS_PATH = '/jobs/posting-options';

  return (
    <div className='cta-nav text-center pt-2 pb-2 ps-0 pe-0'>
      <div className='container'>
        <div className='cta nav-btn-wrapper'>
          <a href={JOB_POSTING_OPTIONS_PATH} className='cta-nav-link'>
            Do you have an open position? <strong>Post a job</strong>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PostJobCtaBanner;
